export type LabelColor =
    | "default"
    | "primary"
    | "secondary"
    | "info"
    | "success"
    | "warning"
    | "error";

export type backendValue = string | null | number;
export default interface FilterConfig {
    table: string;
    url: string;
    statusCountUrl?: string;
    pageSize?: number;
    dataPath?: string;
    tabKey?: string;
    activeOrInactive?: boolean;
    tableTabs?: {
        key: string;
        label: string;
        value: string;
    }[];
    statusOptions?: {
        value: string;
        label: string;
        color: LabelColor;
        backendValue: backendValue;
        condition?: string;
    }[];
    topSectionButtons?: {
        label: string;
        icon: string;
        func: () => void;
        condition?: string;
        color?: string;
    }[];
    filters: Filter[];
}

export interface Filter {
    column: string;
    id: string;
    type: Types;
    options?: any[];
    url?: string;
    start?: number;
    end?: number;
    label: string;
    permission?: string;
    searchType?: SearchTypes;
}

export enum SearchTypes {
    equal = 1,

    like = 2,

    range = 3,

    in = 4,

    notIn = 5,

    greaterThan = 6,

    smallerThan = 7,
}

export enum Types {
    search = "search",
    input = "input",
    singleSelect = "singleSelect",
    multiSelect = "multiSelect",
    multiSelectTabs = "multiSelectTabs",

    numberRange = "numberRange",
    dateDropdown = "dateDropdown",
    date = "date",
    customSearchDropdown = "customSearchDropdown",
    autoCompleteSingleSelect = "autoCompleteSingleSelect",
}
